<template>
<div>
    <div class="boxs">
        <div class="title"> 选择登录企业 </div>
        <div class="company-list">
            <div class="lcpmpy">
                <ul class="lcompy-list" :style="{ marginLeft:marginleftwidth + 'px' }">
                    <li :class="{ active:tindex == 0 }" @click="addCompany">
                        <div class="lcompy-img">
                            <img :src="require('@/assets/images/add_btn.png')"/>
                        </div>
                        <p class="lcompy-name" v-if="tindex == 0 ">添加企业</p>
                    </li>
                    <li :class="{active:tindex == index+1}" v-for="(item,index) in compyList" @click="selCompany(index)" :key="index">
                        <div class="lcompy-img">
                            <img :src="item.logo">
                        </div>
                        <p class="lcompy-name" v-if="tindex == index+1 ">{{item.shortName}}</p>
                    </li>
                </ul>
            </div>
            <div class="iconfont icon-leftback_ico to-left" :class="{blue:letfCan}" @click="goleft"></div>
            <div class="iconfont icon-rightbright to-right" :class="{blue:rightCan}" @click="goright"></div>
        </div>
        <div class="primary-btn" @click="goindex">确定</div>
    </div>
</div>
</template>
<script>
    const qs = require('qs');
    export default {
        data(){
            return {
               compyList:[],
               tindex: 1,
               letfCan:false,
               rightCan:false
            }
        },
        created(){
            this.getcompyList();
            let from = this.$route.query.from;
            if(from){
                if(from == 'hin'){
                    this.$alert('恭喜您成功创建企业，请选择企业登入','',{

                    })
                }
                if(from == 'hon'){
                    this.$alert('恭喜您成功加入企业，请选择企业登入','',{

                    })
                }
            }
        },
        computed:{
            fontSize(){
                return this.$store.getters.fontSize
            },
            marginleftwidth () {
                return this.fontSize * ((this.tindex - 1) * (- 1 * 8.2 ) - (8.2 * 3 - 23.5) / 2)
            }
        },
        watch:{
            compyList(newval,oldval){
                if(newval.length > 1){
                    this.rightCan = true;
                }
            },
            tindex:function (newval,oldval) {
                let len = this.compyList.length;
                if(len > 1){
                    if(newval == len-1){
                        this.rightCan = false;
                        this.letfCan = true;
                        return;
                    }
                    if(newval == 0){
                        this.rightCan = true;
                        this.letfCan = false;
                        return;
                    }
                    if(newval > 0 && newval < len-1){
                        this.rightCan = true;
                        this.letfCan = true;
                        return;
                    }
                }
                if(len == 1){
                    this.rightCan = false;
                    this.letfCan = false;
                }
            }
        },
        methods:{
            addCompany () {
                this.$router.push({path:"/register/join"})
            },
            selCompany(index){
                index = index+1
               if(index > this.tindex){
                   this.goright();
               }
               if(index < this.tindex){
                   this.goleft();
               }
               this.goindex();
            },
            goindex(){
                this.loadingObj = this.$loading();
                let url = `/wapi/hr/swichCompany?companyId=${this.compyList[this.tindex-1].companyId}`
                this.axios.get(url)
                .then(res => {
                    this.loadingObj.close();
                    this.$message({
                        type:'success',
                        message:'登录成功',
                        duration:1500
                    });
                    setTimeout(()=>{
                        
                        if(res.status*1 == 200){
                            this.$router.push({path:"/index/home/index"})
                        }
                    },1000)
                })
            },
            getcompyList(){
                let url = '/wapi/hr/listCompany'
                this.axios.get(url).then(res => {
                    this.compyList = res.data;
                })
            },
            goright(){
                let len = this.compyList.length;
                if(this.tindex < len){
                    this.tindex ++ ;
                }
            },
            goleft(){
                if(this.tindex > 0){
                    this.tindex --;
                }
            }
        }
    }
</script>
 <style scoped lang="less">
@import url('../../assets/less/login.less');
.title{
    margin-bottom: 4.4rem;
}
li{
    &::marker{
        content: '';
    }
}
.company-list{
    height: 11rem;
    width: 23.5rem;
    margin-bottom: 8rem;
    position: relative;
    .iconfont{
        position: absolute;
        top: 3.4rem;
        color: #999;
        font-size: 2rem;
        &.to-left{
            left: -3.4rem;
        }
        &.to-right{
            right: -3.4rem;
        }
    }
    .lcpmpy{
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        .lcompy-list{
            display: flex;
            flex-wrap: nowrap;
            transition: all .3s ease;
            li{
                width: 8rem;
                flex-shrink: 0;
                text-align: center;
                margin: 0 0.1rem;
                line-height: 2.2rem;
                font-size: 1.6rem;
                font-weight: 400;
                color: #333333;
                .lcompy-img{
                    width: 6rem;
                    height: 6rem;
                    margin: 1rem auto;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                &.active .lcompy-img{
                    margin: 0 auto 0.8rem;
                    width: 8rem;
                    height: 8rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// select.vue?5d566105